import { render, staticRenderFns } from "./AddPersonaModal.vue?vue&type=template&id=34cced62&"
import script from "./AddPersonaModal.vue?vue&type=script&lang=ts&"
export * from "./AddPersonaModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddPersonaModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports